export const getNextName = (list, type = 'Rect') => {
  const filtered = list
    .reduce((result, item) => {
      result.push(item);
      if (item.type === 'group' && item.elements?.length) {
        result.push(...item.elements);
      }
      return result;
    }, [])
    .map((item) => {
      const [, num] = item.name?.match(new RegExp(`^${type}\\s*(\\d{0,5})`)) || [];
      return +num;
    })
    .filter((i) => i);

  return `${type} ${Math.max(...filtered, 0) + 1}`;
};

export const getNexIndex = (list, type = 'Rect') => {
  const filtered = list
    .reduce((result, item) => {
      result.push(item);
      if (item.type === 'group' && item.elements?.length) {
        result.push(...item.elements);
      }
      return result;
    }, [])
    .map((item) => {
      const [, num] = item.name?.match(new RegExp(`^${type}\\s*(\\d{0,5})`)) || [];
      return +num;
    })
    .filter((i) => i);

  return Math.max(...filtered, 0) + 1;
};
